import React, { Component } from "react";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export class EditorPost extends Component {
  constructor(props) {
    super(props);
    const html = props.content;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
      };
    }
  }

  onEditorStateChange = (editorState) => {
    this.props.handleInputChange({
      target: {
        name: this.props.name,
        value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      },
    });
    this.setState({
      editorState,
    });
  };

	uploadCallback = () => {
  };

  render() {
    const { editorState } = this.state;
    return (
      <div className="w-100">
        <Editor
          editorState={editorState}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          onEditorStateChange={this.onEditorStateChange}
          toolbar={{
            options: [
              "inline",
              "colorPicker",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
              "image",
              "link",
              "remove",
              "history",
            ],
            inline: {
              options: ["bold", "italic", "underline", "strikethrough"],
            },
            image: {
              urlEnabled: true,
              uploadEnabled: true,
							uploadCallback: this.uploadCallback,
              alignmentEnabled: true,
              previewImage: true,
              inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
            },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true },
          }}
        />
      </div>
    );
  }
}
